// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='2.5 2.5 45 45'
    ...attributes
  ><circle
      cx='25'
      cy='25'
      r='20'
      fill='var(--icon-color, #000)'
      stroke='var(--icon-color, #000)'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='var(--icon-stroke-width, 5)'
    /><circle cx='25' cy='25' r='8' fill='var(--icon-fill-color, #FFF)' /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'IconCircleSelected';
export default IconComponent;
